(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-avis-pdp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.raven-pdpavis').forEach(function (root) {
  var items = root.querySelectorAll('.raven-pdpavis__item');
  var dots = root.querySelectorAll('.raven-pdpavis__dot');
  var current = 0;
  function go(i) {
    current = (i + items.length) % items.length;
    items.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
    dots.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
  }
  root.querySelectorAll('.raven-pdpavis__arrow').forEach(function (btn) {
    btn.addEventListener('click', function () { go(current + parseInt(btn.dataset.dir, 10)); });
  });
  dots.forEach(function (btn) {
    btn.addEventListener('click', function () { go(parseInt(btn.dataset.index, 10)); });
  });
  var timer = null;
  function auto() { clearInterval(timer); if (items.length > 1) timer = setInterval(function () { go(current + 1); }, 6000); }
  root.addEventListener('click', auto);
  root.addEventListener('touchend', auto, { passive: true });
  auto();
  var startX = null;
  root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
    startX = null;
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-collection"]) return;
  try {
    
document.querySelectorAll('#RvnColl').forEach(function (root) {
  var grid = root.querySelector('[data-grid]');
  var items = Array.prototype.slice.call(grid.children);
  function apply() {
    var min = parseFloat((root.querySelector('[data-price-min]').value || '0')) * 100;
    var maxRaw = root.querySelector('[data-price-max]').value;
    var max = maxRaw ? parseFloat(maxRaw) * 100 : Infinity;
    var stock = root.querySelector('[data-filter-stock]').checked;
    var visible = 0;
    items.forEach(function (el) {
      var p = parseInt(el.dataset.price, 10);
      var show = stock && p >= min && p <= max;
      el.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    root.querySelector('.rvn-coll__count').textContent = visible + ' produits';
    var sort = root.querySelector('[data-sort]').value;
    var sorted = items.slice().sort(function (a, b) {
      if (sort === 'price-asc') return a.dataset.price - b.dataset.price;
      if (sort === 'price-desc') return b.dataset.price - a.dataset.price;
      if (sort === 'alpha') return a.dataset.title.localeCompare(b.dataset.title);
      return a.dataset.index - b.dataset.index;
    });
    sorted.forEach(function (el) { grid.appendChild(el); });
  }
  root.querySelectorAll('[data-price-min],[data-price-max]').forEach(function (i) { i.addEventListener('input', apply); });
  root.querySelector('[data-filter-stock]').addEventListener('change', apply);
  root.querySelector('[data-sort]').addEventListener('change', apply);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-compare"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rvn-compare-container').forEach(function (box) {
  var clip = box.querySelector('[data-clip]');
  var handle = box.querySelector('[data-handle]');
  var fg = clip.querySelector('.rvn-compare-fg');
  var dragging = false;
  function sync() { fg.style.width = box.offsetWidth + 'px'; }
  function move(clientX) {
    var r = box.getBoundingClientRect();
    var p = ((clientX - r.left) / r.width) * 100;
    if (p < 2) p = 2;
    if (p > 98) p = 98;
    clip.style.width = p + '%';
    handle.style.left = p + '%';
  }
  box.addEventListener('mousedown', function (e) { e.preventDefault(); dragging = true; move(e.clientX); });
  document.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
  document.addEventListener('mouseup', function () { dragging = false; });
  box.addEventListener('touchstart', function (e) { dragging = true; move(e.touches[0].clientX); }, { passive: true });
  document.addEventListener('touchmove', function (e) { if (dragging) move(e.touches[0].clientX); }, { passive: true });
  document.addEventListener('touchend', function () { dragging = false; });
  window.addEventListener('resize', sync);
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-icons-row"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.raven-icons').forEach(function (root) {
  var items = root.querySelectorAll('.raven-icons__item');
  var dots = root.querySelectorAll('.raven-icons__dot');
  var current = 0;
  function go(i) {
    current = (i + items.length) % items.length;
    items.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
    dots.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
  }
  dots.forEach(function (btn) { btn.addEventListener('click', function () { go(parseInt(btn.dataset.index, 10)); }); });
  var startX = null;
  root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
    startX = null;
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-offer-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-rvocta]');
  if (!btn) return;
  var target = document.querySelector('#raven-pdp .kaching-bundles') || document.getElementById('RavenProductForm');
  if (!target) return;
  e.preventDefault();
  var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
  window.scrollTo({ top: top, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-suivi"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('RvnSuiviForm');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var order = document.getElementById('RvnSuiviOrder');
    var email = document.getElementById('RvnSuiviEmail');
    var tracking = document.getElementById('RvnSuiviTracking');
    var gOrder = order.closest('.rvn-suivi__group');
    var gEmail = email.closest('.rvn-suivi__group');
    gOrder.classList.remove('is-err'); gEmail.classList.remove('is-err');
    var viaTracking = tracking.value.trim().length > 0;
    if (!viaTracking) {
      var ok = true;
      if (!order.value.trim()) { gOrder.classList.add('is-err'); ok = false; }
      if (!email.value.trim()) { gEmail.classList.add('is-err'); ok = false; }
      if (!ok) return;
    }
    var res = document.getElementById('RvnSuiviResult');
    res.hidden = false;
    res.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-timeline"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.raven-timeline').forEach(function (root) {
  var items = root.querySelectorAll('.raven-timeline__item');
  var navs = root.querySelectorAll('.raven-timeline__nav-item');
  var arrows = root.querySelectorAll('.raven-timeline__arrow');
  var current = 0;
  function go(i) {
    current = Math.max(0, Math.min(items.length - 1, i));
    items.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
    navs.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
    arrows.forEach(function (btn) {
      var dir = parseInt(btn.dataset.dir, 10);
      btn.disabled = (dir === -1 && current === 0) || (dir === 1 && current === items.length - 1);
    });
  }
  arrows.forEach(function (btn) {
    btn.addEventListener('click', function () { go(current + parseInt(btn.dataset.dir, 10)); });
  });
  navs.forEach(function (btn) {
    btn.addEventListener('click', function () { go(parseInt(btn.dataset.index, 10)); });
  });
  var startX = null;
  root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
    startX = null;
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raven-video-mobile"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rvn-video-mobile').forEach(function (root) {
  var video = root.querySelector('video');
  if (!video) return;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { try { video.play().catch(function () {}); } catch (e) {} }
        else { try { video.pause(); } catch (e) {} }
      });
    }, { threshold: 0.25 }).observe(root);
  }
});

  } catch(e) { console.error(e); }
})();
})();
